import useResetPassword from './useResetPassword';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import Container from '@/components/Container';
import Button from '@/components/Button';

const ForgotPassword = () => {
  const { forgotPasswordPage, handleSubmitForgotPassword, registerForgotPassword, isLoading } = useResetPassword();

  if (!forgotPasswordPage) return null;

  return (
    <Container className="h-full">
      <div className="col-span-12 flex items-center justify-center">
        <div
          className="flex max-h-[90vh] w-full max-w-[430px] flex-col items-start overflow-auto rounded-2xl bg-white p-8"
          style={{ boxShadow: '0px 0px 20px 0px #86AAD5' }}>
          <div className=" mr-14 flex flex-col items-start">
            <img
              className="mb-11 h-[30px] w-auto"
              src={forgotPasswordPage?.logo.data?.attributes?.url}
              alt={forgotPasswordPage?.logo.data?.attributes?.alternativeText || 'Logo'}
            />
          </div>
          <div className=" flex flex-col items-start">
            <h2 className=" mb-4 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
              {forgotPasswordPage?.forgotPasswordTItle}
            </h2>

            <p className=" mb-4 text-sh-sm">{forgotPasswordPage?.letUsKnowDescription}</p>

            <form onSubmit={handleSubmitForgotPassword} className="w-full">
              <div className=" mb-8 w-full">
                <Label>
                  <p className="mb-2 text-sh-xs">{forgotPasswordPage?.yourEmail}</p>
                </Label>
                <Input placeholder={forgotPasswordPage?.yourEmail} type="email" {...registerForgotPassword('email')} />
              </div>

              <Button type="submit" theme="solid" className="mb-4" loading={isLoading}>
                {forgotPasswordPage?.sendMeCta}
              </Button>
            </form>

            <a className=" text-sh-xs font-bold text-[#1775E3] underline" href="/login">
              {forgotPasswordPage?.backToLoginCta}
            </a>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ForgotPassword;
